module.exports = __webpack_public_path__ + "img/wangqianwen.cc5588b4.png";